import React, { useState } from 'react';

import InfoIcon from '@mui/icons-material/Info';
import { useTheme } from '@mui/material/styles';
import {
    ClickAwayListener,
    IconButton,
    Tooltip,
} from '@sunwisesoftware/sunwise-ui';
import PropTypes from 'prop-types';

const InfoPopover = ({
    children,
    color = null,
    placement = 'left-start',
    size = 'small',
    sx,
}) => {
    const theme = useTheme();
    const [open, setOpen] = useState(false);
    const handleTooltipClose = () => setOpen(false);
    const handleTooltipOpen = () => setOpen(true);
    return (
        <ClickAwayListener onClickAway={handleTooltipClose}>
            <Tooltip
                componentsProps={{ tooltip: { sx } }}
                disableFocusListener
                disableHoverListener
                disableTouchListener
                onClose={handleTooltipClose}
                open={open}
                placement={placement}
                title={children}
            >
                <IconButton onClick={handleTooltipOpen} sx={{ ml: 'auto' }}>
                    <InfoIcon
                        fontSize="inherit"
                        size={size}
                        sx={{ color: color || theme.palette.primary.main }}
                    />
                </IconButton>
            </Tooltip>
        </ClickAwayListener>
    );
};

InfoPopover.propTypes = {
    children: PropTypes.oneOfType([PropTypes.array, PropTypes.node]),
    color: PropTypes.string,
    placement: PropTypes.string,
    size: PropTypes.string,
    sx: PropTypes.object,
};

export default InfoPopover;
